import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.28434 2C2.57596 2 2 2.58269 2 3.30148V18.6303C2 19.352 2.57502 19.9318 3.28434 19.9318H6.56779L5.73301 23.4648L10.2851 19.9318H22.1805C22.8888 19.9318 23.4648 19.3491 23.4648 18.6303V3.30148C23.4648 2.57978 22.8897 2 22.1805 2H3.28434Z",
      stroke: "#0C8A65",
      "stroke-width": "1.8665"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.66626 22.4126H19.2927L23.0531 25.3312L22.3635 22.4126H25.0759C25.6618 22.4126 26.1368 21.9336 26.1368 21.3375V8.6745C26.1368 8.08072 25.661 7.59937 25.0759 7.59937H23.4648",
      stroke: "#0C8A65",
      "stroke-width": "1.54189",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.1376 7.47152C15.987 6.38816 14.1203 6.38816 12.9684 7.47152L12.6943 7.72931L12.4203 7.47152C11.2697 6.38816 9.40293 6.38816 8.25249 7.47152C7.67595 8.01261 7.38892 8.72268 7.38892 9.43151C7.38892 10.1403 7.67595 10.8505 8.25249 11.3915L8.52657 11.6493L12.2777 15.1783C12.5079 15.3949 12.8812 15.3949 13.1114 15.1784L17.1378 11.3914C17.713 10.8504 18 10.1403 18 9.43143C18 8.7226 17.713 8.01252 17.1378 7.47144L17.1376 7.47152Z",
      fill: "#0C8A65"
    }, null, -1)
  ]))]))
}
export default { render: render }